<template>
    <v-container>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <p class="ma-0 title">Yritä hakea listoja etäpalvelimelta</p>
                        <p class="ma-0">Vain suorat, yhteensopivan formaatin PDF. Esim. <a target="blank" href="https://www.kiuruvesi.fi/Suomeksi/Palvelut/Ruokapalvelut/Ruokalistat">730</a> tässä.</p>
                    </v-col>
                    <v-col cols="12" lg="8">
                        <v-text-field
                        label="PDF-resurssin url"
                        hide-details
                        outlined
                        v-model="url"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <v-btn
                        color="green"
                        dark
                        block
                        x-large
                        @click="scrape"
                        :loading="loading"
                        >
                        Etsi</v-btn>
                    </v-col>
                    <v-dialog
                    :value="lists.length > 0"
                    width="500"
                    >
                        <v-card>
                            <v-container>
                                <v-row v-for="(list, index) in lists" :key="index">
                                    <v-col cols="12" md="8">
                                        <v-text-field
                                        hide-details
                                        outlined
                                        v-model="list.data"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                        hide-details
                                        outlined
                                        v-model="list.date"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                            <v-card-actions>
                                <v-btn
                                color="primary"
                                @click="saveToServer"
                                :loading="saving"
                                >Tallenna</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import axios from "axios";

export default {
    data() {
        return {
            url: '',
            loading: false,
            saving: false,
            lists: [],
            dialogIsOpen: false
        }
    },
    methods: {
        scrape() {
            if (!this.url) {
                alert('URL-osoite ei voi olla tyhjä!')
                return
            }
            this.loading = true;

            let data = new FormData();
            data.set('language', 'fin');
            data.set('isOverlayRequired', true);
            data.set('url', this.url);

            axios.post('https://api.ocr.space/parse/image', data,
            {
                headers: {
                    apikey: 'b88de2b08f88957'
                }
            })
            .then((response) => {
                
                let finish = []
                
                const lines = response.data.ParsedResults[0].TextOverlay.Lines
                
                let curBuffer = []
                let curDate = ''

                for (let i = 0; i < lines.length; i++) {
                    const line = lines[i];

                    // PVM -> yyyy-mm-dd
                    // Aloittaa bufferin alusta
                    if (/(MAANANTAI)|(TIISTAI)|(KESKIVIIKKO)|(TORSTAI)|(PERJANTAI)|(LAUANTAI)|(SUNNUNTAI)|d+/.test(line.LineText)) {
                        if (curDate) {
                            curBuffer = curBuffer.join(', ')
                            curBuffer = curBuffer.toLowerCase();
                            curBuffer = curBuffer.charAt(0).toUpperCase() + curBuffer.slice(1)
                            finish.push({ data: curBuffer, date: curDate })
                        }
                        // uusinta huutoa oleva aikaparseri :D
                        let dateString = line.LineText.split(' ')[1];
                        if (!dateString) {
                            curDate = new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000 ))
                                .toISOString()
                                .split("T")[0];
                            curBuffer = []
                            continue
                        }
                        dateString = dateString.split(/\./).reverse()
                        if (dateString.length === 2) { dateString.push(new Date().getFullYear()) }
                        dateString = dateString.join('/')
                        let date = new Date(dateString);
                        let yyyymmdd = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 ))
                            .toISOString()
                            .split("T")[0];

                        curBuffer = []
                        curDate = yyyymmdd
                    } else {
                        curBuffer.push(line.LineText)
                    }
                }

                curBuffer = curBuffer.join(', ')
                curBuffer = curBuffer.toLowerCase();
                curBuffer = curBuffer.charAt(0).toUpperCase() + curBuffer.slice(1)
                finish.push({ data: curBuffer, date: curDate })

                this.lists = [ ...finish ]
            })
            .catch(e => {
                alert(e)
            })
            .finally(() => {
                this.loading = false;
            })
        },
        saveToServer() {
            this.saving = true
            let ctr = 0
            this.lists.forEach((list, index, array) => {
                let form_data = Object.entries(list).map(([key, valu]) => `${key}=${valu}`).join('&');

                axios.post('https://apiv4.kiuruvesi.net/list' + this.$store.getters.placeid,
                form_data,
                {
                    headers: {
                    "Authorization" : 'Bearer ' + this.$store.getters.token,
                    'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                .catch(function (e) {
                    alert(e)
                })
                .finally(() => {
                    ctr++; 
                    if (ctr === array.length) {
                        location.reload();
                    }
                })
            })
        }
    }
}
</script>